import {
  Box,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import SearchComponent from "../../../components/SearchComponent";
import Compdirection from "../../../themes/CompDirection";
import { fonts, themes } from "../../../themes/themes";
import CustomModal from "../../CustomModal/CustomModal";
import ModalHeader from "../../CustomModal/ModalHeader";
import "../TrainingModal.css";
import EmpProfile from "../../../components/EmpProfile/EmpProfile";
import ModalFooter from "../../CustomModal/ModalFooter";
import { data } from "jquery";
import { useAppSelector } from "../../../../infra/hooks";
import _ from "lodash";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trainees_DataList: any;
  setPayload?: any;
  trans: any;
  i18n?: any;
}

const GreenSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: themes.green,
    "&:hover": {
      backgroundColor: alpha(themes.green, theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "green",
  },
}));
const MarkasCompletePresenter = ({
  isModalOpen,
  closeModal,
  trainees_DataList,
  setPayload,
  trans,
  i18n,
}: ModalProps) => {
  const [pageSize, setPageSize] = React.useState<number>(30);

  const [traineesDataList, setTraineesDataList] = useState(trainees_DataList);
  const selector = useAppSelector((state) => state.authSlice);
  const [textFiltertraining, setTextFiltertraining] = useState("");

  const handleSubmit = () => {
    const temp: any = [];
    traineesDataList?.map((d: any) => {
      const obj = {
        training_id: d?.training_id,
        emp_id: d?.empId,
        company_id: selector.company_id,
        score: d?.score,
        evaluation_status: d?.status ? 1 : 0,
      };
      temp.push(obj);
    });

    setPayload({
      markascomplete: temp,
    });
    closeModal();
  };
  const filtertrainingList = () => {
    if (textFiltertraining.length) {
      const txt = textFiltertraining.toLowerCase();
      const res = _.filter(traineesDataList, function (e) {
        return e?.employee.toLowerCase().includes(txt);
      });

      {
        return res;
      }
    } else {
      return traineesDataList;
    }
  };
  const tableColumns: any = [
    {
      field: "empId",
      headerName: trans("Emp Id"),
      width: 100,
      headerClassName: "header",
      height: 100,
    },

    {
      field: "employee",
      headerName: trans("Employee"),
      width: 250,
      headerClassName: "header",
      height: 100,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <EmpProfile avatar={params.row.avatar} name={params.row.employee} />
        );
      },
    },
    {
      field: "designation",
      headerName: trans("Designation"),
      width: 200,
      headerClassName: "header",
      height: 100,
    },
    {
      field: "score",
      headerName: trans("Score"),
      width: 100,
      headerClassName: "header",
      height: 100,

      renderCell: (params: any) => {
        const handleChange = (event: any, id: any) => {
          // Find the index of the row to update
          const rowIndex = traineesDataList.findIndex(
            (row: any) => row.id === id
          );

          // Create a new copy of the row with the updated value
          const updatedRow = {
            ...traineesDataList[rowIndex],
            score: event.target.value,
          };

          // Create a new copy of the rows array with the updated row
          const updatedRows = [...traineesDataList];
          updatedRows[rowIndex] = updatedRow;

          // Set the state with the updated rows array
          setTraineesDataList(updatedRows);
          //setscoreValue(event.target.value);
        };

        return (
          <TextField
            value={params.value}
            onChange={(e: any) => handleChange(e, params.id)}
            inputProps={{ style: { height: "2px", width: "3em" } }}
          />
        );
      },
    },

    {
      field: "status",
      headerName: trans("Status"),
      width: 140,
      headerClassName: "header",
      height: 100,

      renderCell: (params: any) => {
        const handleChange = (event: any, id: any) => {
          // Find the index of the row to update
          const rowIndex = traineesDataList.findIndex(
            (row: any) => row.id === id
          );

          // Create a new copy of the row with the updated value
          const updatedRow = {
            ...traineesDataList[rowIndex],
            status: event.target.checked,
          };

          // Create a new copy of the rows array with the updated row
          const updatedRows = [...traineesDataList];
          updatedRows[rowIndex] = updatedRow;

          // Set the state with the updated rows array
          setTraineesDataList(updatedRows);
          //setscoreValue(event.target.value);
        };

        return (
          <FormControlLabel
            control={
              <GreenSwitch
                checked={params.row.status}
                onChange={(e: any) => {
                  handleChange(e, params.id);
                }}
              />
            }
            label={params.row.status ? trans("Present") : trans("Absent")}
            style={{
              color: params.row.status ? themes.green : "red",
              fontSize: "0.85em",
            }}
          />
        );
      },
    },
  ];
  const handleGetTextFilter = (value: any) => {
    setTextFiltertraining(value);
  };
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="650px"
      modalWidth="1000px"
    >
      <ModalHeader
        modal={{ modal_title: trans("Mark as Complete") }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "10px",
          }}
        >
          <Grid item xs={12}>
            <Box className="modalBox24">
              <Typography className="title1">
                {trans("Total Trainee :")} {traineesDataList?.length}
              </Typography>
              <Grid container style={{ marginTop: "1em" }}>
                <Grid item>
                  <SearchComponent onChange={handleGetTextFilter} />
                </Grid>
              </Grid>
              <Box
                sx={{
                  "& .header": {
                    backgroundColor: "#F5F5F5",
                  },
                }}
                className="mark_as_complete_table"
              >
                <DataGrid
                  sx={{
                    fontSize: fonts.subtitle,
                    color: "#081735",
                    fontFamily: fonts.fontFamily,
                    marginTop: "1.5em",
                  }}
                  autoHeight
                  pageSize={pageSize}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  rowsPerPageOptions={[30, 35]}
                  // pageSize={30}

                  checkboxSelection
                  onRowClick={(params) => console.log("chat", params.row)}
                  rows={filtertrainingList()}
                  columns={tableColumns}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Compdirection>
      <Box style={{ marginTop: "35px" }} />
      <ModalFooter onClickSubmit={handleSubmit} onClickCancel={closeModal} />
    </CustomModal>
  );
};
export default MarkasCompletePresenter;
